module.exports = __webpack_public_path__ + "img/Foto-De-Jonge-Johannes5-e1497293283452.c8a6b714.jpg";